function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Product",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "logo/blue",
  transform: "translate(0.000000, -1.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-17"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-1",
  fill: "#001593",
  points: "189.758735 75.5753149 209.199895 75.5753149 209.199895 27.5576074 189.758735 27.5576074"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-2",
  fill: "#001593",
  points: "114.323057 75.5753149 133.764216 75.5753149 133.764216 14.371415 114.323057 14.371415"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-3",
  fill: "#001593",
  points: "105.322582 42.6815072 142.76469 42.6815072 142.76469 27.5609802 105.322582 27.5609802"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-16",
  transform: "translate(0.000000, 0.893470)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M209.866709,11.2338129 C209.866709,16.9997154 205.191926,21.674498 199.426024,21.674498 C193.660121,21.674498 188.985339,16.9997154 188.985339,11.2338129 C188.985339,5.46791041 193.660121,0.7931278 199.426024,0.7931278 C205.191926,0.7931278 209.866709,5.46791041 209.866709,11.2338129",
  id: "Fill-4",
  fill: "#001593"
}), /*#__PURE__*/React.createElement("path", {
  d: "M299.224369,65.0933123 C299.224369,70.8592148 294.549586,75.5339974 288.783684,75.5339974 C283.017781,75.5339974 278.342999,70.8592148 278.342999,65.0933123 C278.342999,59.3274097 283.017781,54.6526271 288.783684,54.6526271 C294.549586,54.6526271 299.224369,59.3274097 299.224369,65.0933123",
  id: "Fill-6",
  fill: "#001593"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.0746983,40.052195 C83.0746983,39.2460817 83.8201001,38.0402846 86.3767273,38.0402846 C87.8877681,38.0402846 91.0144084,38.5597049 93.9791515,39.6339605 L93.9740922,39.6289012 C94.0735916,39.6660026 94.1646588,39.7014177 94.2590988,39.7368327 C94.793697,39.9392042 95.319863,40.1567536 95.8291647,40.3945402 C97.4616285,41.1433149 98.406029,41.8313781 99.5662925,42.6863979 C99.6118261,42.7184401 99.6523004,42.7521686 99.6910883,42.7858972 L99.6910883,27.5709302 C96.921971,27.4697444 91.8087167,25.6568327 85.6313254,25.6568327 C71.6778076,25.6568327 63.7954361,31.2945665 63.7954361,41.6627352 C63.7954361,56.5623399 82.6480316,57.3667668 82.6480316,60.9909038 C82.6480316,61.7970171 82.1168063,62.8021291 79.9851594,62.8021291 C77.3121686,62.8021291 72.3135916,61.4411805 68.2459236,59.5574387 C65.5611278,58.4545138 64.4885586,57.744527 63.1562793,56.8018129 L63.1562793,73.1719842 C66.0333281,73.1719842 74.1281897,75.8888221 80.7305613,75.8888221 C95.2169908,75.8888221 102.14147,69.0436047 102.14147,59.6822345 C102.14147,44.7843162 83.0746983,43.5751462 83.0746983,40.052195",
  id: "Fill-8",
  fill: "#001593"
}), /*#__PURE__*/React.createElement("g", {
  id: "Clip-11"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-10",
  fill: "#001593",
  points: "38.0272991 74.683531 57.4684585 74.683531 57.4684585 26.6658235 38.0272991 26.6658235"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.984664,41.3136443 C23.8157576,41.3136443 19.6249802,45.5044216 19.6249802,50.6750145 C19.6249802,55.8456074 23.8157576,60.0380711 28.984664,60.0380711 C34.1552569,60.0380711 38.3460343,55.8456074 38.3460343,50.6750145 C38.3460343,45.5044216 34.1552569,41.3136443 28.984664,41.3136443 M46.4442688,50.6750145 C46.4442688,64.4042372 36.0457444,75.5346719 23.2221344,75.5346719 C10.3968379,75.5346719 0,64.4042372 0,50.6750145 C0,36.9457918 10.3968379,25.8170435 23.2221344,25.8170435 C36.0457444,25.8170435 46.4442688,36.9457918 46.4442688,50.6750145",
  id: "Fill-12",
  fill: "#001593"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-13",
  fill: "#001593",
  points: "252.020026 74.683531 271.461186 74.683531 271.461186 0.792621871 252.020026 0.792621871"
}), /*#__PURE__*/React.createElement("path", {
  d: "M242.978403,41.3136443 C237.809497,41.3136443 233.617033,45.5044216 233.617033,50.6750145 C233.617033,55.8456074 237.809497,60.0380711 242.978403,60.0380711 C248.14731,60.0380711 252.338087,55.8456074 252.338087,50.6750145 C252.338087,45.5044216 248.14731,41.3136443 242.978403,41.3136443 M260.436321,50.6750145 C260.436321,64.4042372 250.039484,75.5346719 237.215874,75.5346719 C224.390577,75.5346719 213.993739,64.4042372 213.993739,50.6750145 C213.993739,36.9457918 224.390577,25.8170435 237.215874,25.8170435 C250.039484,25.8170435 260.436321,36.9457918 260.436321,50.6750145",
  id: "Fill-14",
  fill: "#001593"
}), /*#__PURE__*/React.createElement("path", {
  d: "M177.029903,43.1063188 C179.67591,43.1063188 182.225792,44.2075573 184.050509,45.9648169 L184.050509,26.2521423 C184.050509,26.2521423 182.770509,25.6568327 180.215568,25.6568327 C173.291088,25.6568327 168.354909,29.2253175 166.113644,35.3234466 L166.113644,26.6636311 L148.473592,26.6636311 L148.473592,74.6813386 L167.914751,74.6813386 L167.914751,52.9314572 C167.914751,46.966556 171.99591,43.1063188 177.029903,43.1063188",
  id: "Fill-15",
  fill: "#001593"
})))));

function SvgAstridLogoBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "76px",
    viewBox: "0 0 300 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = React.forwardRef(SvgAstridLogoBlue);
export default __webpack_public_path__ + "static/media/astrid_logo_blue.35bb0771.svg";
export { ForwardRef as ReactComponent };